/**
 * Detalhe do agendamento de doca (#MT-B2FA396 Fase 3B).
 */
const ICO_CAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/></svg>';

export default {

	html: `
		<style>
			#input_dock_schedule_detail .ids-tl {
				list-style: none;
				margin: 0;
				padding: 0;
			}
			#input_dock_schedule_detail .ids-tl li {
				position: relative;
				padding: 0.55rem 0.75rem 0.55rem 1.35rem;
				border-left: 2px solid #c7d2fe;
				margin-left: 0.4rem;
			}
			#input_dock_schedule_detail .ids-tl li::before {
				content: '';
				position: absolute;
				left: -0.4rem;
				top: 0.75rem;
				width: 0.55rem;
				height: 0.55rem;
				border-radius: 50%;
				background: #4c1d95;
			}
			#input_dock_schedule_detail .ids-tl .ids-tl-type {
				font-weight: 600;
				color: #1e3a8a;
			}
			#input_dock_schedule_detail .ids-tl .ids-tl-when {
				font-size: 0.78rem;
				color: #6b7280;
			}
			#input_dock_schedule_detail .ids-kv {
				display: grid;
				grid-template-columns: 8.5rem 1fr;
				gap: 0.25rem 0.75rem;
				font-size: 0.88rem;
			}
			#input_dock_schedule_detail .ids-kv dt { color: #6b7280; }
			#input_dock_schedule_detail .ids-kv dd { margin: 0; color: #111827; }
		</style>
		<form id="input_dock_schedule_detail" class="form sial-modal-form sial-detail" autocomplete="off">
			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon">${ICO_CAL}</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Movimentação · Agendamento de Docas</p>
						<h2 class="sdp-title" data-sdp="title">Detalhe do agendamento</h2>
						<div class="sdp-meta">
							<span>ID: <b data-sdp="id">—</b></span>
							<span class="sdp-badge sdp-badge--free" data-sdp="status">—</span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">×</button>
			</header>

			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">Dados principais</h3>
					<dl class="ids-kv" id="ids_detail_main"></dl>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">Pedido / fornecedor</h3>
					<dl class="ids-kv" id="ids_detail_order"></dl>
					<p class="sdp-hint" id="ids_detail_notes"></p>
				</div>
			</section>

			<div class="sdp-stack">
				<div class="sdp-block">
					<h3 class="sdp-block-title">Histórico de eventos</h3>
					<ul class="ids-tl" id="ids_detail_events"></ul>
				</div>
				<div class="sdp-block" id="ids_detail_occ_block" hidden>
					<h3 class="sdp-block-title">Ocorrências</h3>
					<ul class="ids-tl" id="ids_detail_occs"></ul>
				</div>
			</div>

			<div class="sdp-foot">
				<button type="button" class="button" id="ids_detail_cancel">Cancelar agendamento</button>
				<button type="button" class="button" id="ids_detail_reschedule">Reagendar</button>
				<button class="bn_Escape button">Fechar</button>
			</div>
		</form>
	`,

	form: {
		selector: '#input_dock_schedule_detail',
		init()
		{
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [],
};
